import { AlertOutlineIcon } from '@atgfr8/icons';
export const ReferenceWarning = () => {
  return (
    <div class="w-full rounded-lg px-2 py-1 border-solid border-[#f7b151] border-2 bg-[#fff8e1] font-roboto text-sm ">
      <div class="flex items-center gap-x-2">
        <AlertOutlineIcon color="#f7b151" />
        <div class="flex flex-col w-full">
          This reference number may be used for customer tracking. Visibility
          within tech tracking. When applicable, updating it will automatically
          update the tracking details for the customer.
        </div>
      </div>
    </div>
  );
};
